import React, { useEffect, useState } from 'react'
import Modal from 'react-modal'
import { getExtraInfoTabletInformeFacturacionStyles } from '../utils/styles'
import closeIcon from "../../assets/img/cross-modal-mobile.png";
import Select from "react-select";
import { SingleOption, customStylesTctTae, getExcelWithXlsx2, getLocaleStringNumber, orderArray, parseBudat, parseDate, parseDateAmerican } from "../utils/utils.js";
import ReactDatePicker from 'react-datepicker';
import { hideGreyBackground } from '../utils/windows.js';

const FiltrosModalMobile = ({
  isOpenFiltroModal,
  setIsOpenFiltroModal,
  selectedEds,
  changeEds,
  allEds,
  selectedTipoFecha,
  changeTipoFecha,
  allTipoFecha,
  changeFechaInicio,
  fechaFin,
  setFechaFin,
  fechaInicio,
  getMaxDate,
  selectedTipo,
  changeGrupoArticulos,
  allTipos,
  allFilters,
  tipoFecha,
  setAllTipoFecha,
  setSelectedTipo,
  setSelectedTipoFecha,
  setFechaInicio
}) => {

  const [enableButton, setEnableButton] = useState(false)

  const closeFiltrosMobileModal = () => {
    hideGreyBackground()
    setIsOpenFiltroModal(false)
  }

  useEffect(() => {
    if (selectedTipoFecha && fechaInicio && fechaFin && selectedTipo) {
      console.log('selectedTipoFecha', selectedTipoFecha)
      console.log('fechaInicio', fechaInicio)
      console.log('fechaFin', fechaFin)
      console.log('selectedTipo', selectedTipo)

      setEnableButton(true)
    }else{
      setEnableButton(false)
    }
  }, [selectedTipoFecha, fechaInicio, fechaFin, selectedTipo])

  const handleLimpiarButton = () => {
    setFechaFin()
    setFechaInicio()
    setAllTipoFecha(tipoFecha)
    setSelectedTipo({
      value: "TOD",
      label: "Todos"
    })
    setSelectedTipoFecha(tipoFecha[1])
  }
  

  return (
    <Modal
      isOpen={isOpenFiltroModal}
      onRequestClose={closeFiltrosMobileModal}
      style={getExtraInfoTabletInformeFacturacionStyles()}
    >
     <div className="filtros-modal-mobile-main-container">
      <div className="header-container">
        <div className="label">
          Seleccionar Filtros
        </div>
        <img src={closeIcon} onClick={closeFiltrosMobileModal}/>
      </div>
      <div className="modal-mobile-separator"></div>
      <div className="filters-container">
        <div className="filter no-display-in-mobile">
          <div className="filter-title required-field">
            TIPO DE FECHA
          </div>
          <div className="filter-input">
            <Select
              className="eds-select"
              value={selectedTipoFecha}
              onChange={(e) => changeTipoFecha(e)}
              closeMenuOnSelect={true}
              hideSelectedOptions={false}
              options={allTipoFecha}
              components={{
                SingleOption,
                IndicatorSeparator: () => null,
              }}
              isClearable={false}
              autosize={false}
              placeholder="Seleccionar"
              styles={customStylesTctTae}
              width={"100%"}
              isDisabled={true}
            />
          </div>
        </div>
        <div className="filter no-display-in-mobile">
          <div className="filter-title required-field">
            FECHA INICIO
          </div>
          <div className="filter-input fecha">
            <ReactDatePicker
              locale="es"
              selected={fechaInicio}
              onChange={(e) => changeFechaInicio(e)}
              shouldCloseOnSelect={true}
              dateFormat="dd/MM/yyyy"
              maxDate={new Date()}
              minDate={new Date(2023, 0, 1)}
              placeholderText="Seleccionar"
            />
          </div>
        </div>
        <div className="filter no-display-in-mobile">
          <div className="filter-title required-field">
            FECHA FIN
          </div>
          <div className="filter-input fecha">
            <ReactDatePicker
              locale="es"
              selected={fechaFin}
              onChange={(e) => setFechaFin(e)}
              shouldCloseOnSelect={true}
              dateFormat="dd/MM/yyyy"
              minDate={fechaInicio}
              maxDate={getMaxDate(fechaInicio)}
              placeholderText="Seleccionar"
              disabled={fechaInicio ? false : true}
            />
          </div>
        </div>
        <div className="filter no-display-in-mobile">
          <div className="filter-title">
            TIPO
          </div>
          <div className="filter-input">
            <Select
              className="grupo-articulos-select"
              value={selectedTipo}
              onChange={(e) => changeGrupoArticulos(e)}
              closeMenuOnSelect={true}
              hideSelectedOptions={false}
              options={allTipos}
              components={{
                SingleOption,
                IndicatorSeparator: () => null,
              }}
              isClearable={false}
              autosize={false}
              placeholder="Seleccionar"
              styles={customStylesTctTae}
              width={"100%"}
            />
          </div>
        </div>
      </div>
      <div className="button-container">
        <button onClick={handleLimpiarButton} className="main-button hallow">Borrar Filtros</button>
        <button disabled={!enableButton} className="main-button" onClick={allFilters}>Aplicar Filtros</button>
      </div>
     </div>
    </Modal>
  )
}

export default FiltrosModalMobile